import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-03-14 20:16:58
 * @LastEditTime: 2022-04-21 15:02:38
 * @FilePath: \insurforce-backstage-platform-side\src\views\customer\roleManage\utils.js
 */
// 客户数据权限table
const COLUMNS = [{
  slots: {
    title: '部门'
  },
  dataIndex: 'structureName',
  key: 'structureName',
  align: 'center',
  ellipsis: true,
  scopedSlots: {
    customRender: 'structureName'
  }
  // customRender: (text, row, index) => {
  //   let result = !text || row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? '—' : text;
  //   let isSpan = row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? row.menuNameRowSpan : '';
  //   const obj = {
  //     children: result,
  //     attrs: {
  //       rowSpan: isSpan
  //     }
  //   };
  //   return obj;
  // }
}, {
  slots: {
    title: '应用'
  },
  dataIndex: 'appName',
  key: 'appName',
  align: 'center',
  ellipsis: true,
  customRender: (text, row, index) => {
    let result = !text || row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? '—' : text;
    let isSpan = row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? row.menuNameRowSpan : '';
    const obj = {
      children: result,
      attrs: {
        rowSpan: isSpan
      }
    };
    return obj;
  }
}, {
  slots: {
    title: '中介'
  },
  dataIndex: 'agencyName',
  key: 'agencyName',
  align: 'center',
  ellipsis: true,
  scopedSlots: {
    customRender: 'agencyName'
  }
  // customRender: (text, row, index) => {
  //   let result = !text || row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? '—' : text;
  //   let isSpan = row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? row.menuNameRowSpan : '';
  //   const obj = {
  //     children: (
  //       <a-tooltip placement="topLeft" title={result}>
  //         {result}
  //       </a-tooltip>
  //     ),
  //     attrs: {
  //       rowSpan: isSpan
  //     }
  //   };
  //   return obj;
  // }
}, {
  slots: {
    title: '销售渠道'
  },
  dataIndex: 'customerName',
  key: 'customerName',
  align: 'center',
  ellipsis: true,
  customRender: (text, row, index) => {
    let result = !text || row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? '—' : text;
    let isSpan = row.authorityTypeValue === 1 || row.authorityTypeValue === 2 ? row.menuNameRowSpan : '';
    const obj = {
      children: result,
      attrs: {
        rowSpan: isSpan
      }
    };
    return obj;
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 160,
  scopedSlots: {
    customRender: 'operation'
  }
}];

// 表单校验规则
const DATA_SCOPE_RULES = {
  departmentValue: [{
    required: true,
    message: '请选择部门',
    trigger: 'change'
  }],
  applicationValue: [{
    required: true,
    message: '请选择应用',
    trigger: 'change'
  }]
};
const DATA_AUTHORITY_TYPE = [{
  name: '个人',
  value: 1
}, {
  name: '全部',
  value: 2
}, {
  name: '指定部门',
  value: 3
}, {
  name: '所属部门',
  value: 4
}];
const REPLACE_DEPARTMENT_FIELDS = {
  children: 'children',
  title: 'name',
  key: 'id',
  value: 'id'
};
const AUTHORITY_TAGTYPE = {
  0: ['structureName', 'appName', 'operation'],
  2: ['structureName', 'appName', 'customerName', 'operation']
};

// 合并客户角色数据权限菜单table列
const mergeCells = (_data, key, radioValue = 1, permissionsId) => {
  let arr = _data.reduce((result, item) => {
    if (result.indexOf(item[key]) < 0) {
      result.push(item[key]);
    }
    return result;
  }, []).reduce((result, keys) => {
    const children = _data.filter(item => item[key] === keys);
    result = result.concat(children.map((item, index) => ({
      ...item,
      [`${key}RowSpan`]: index === 0 ? children.length : 0,
      // 判断当前切换radio为此合并菜单
      authorityTypeValue: permissionsId === item.permissionsId ? radioValue : item.authorityTypeValue
    })));
    return result;
  }, []);
  _data = arr;
  return _data;
};

// 深拷贝对象
const recursionCopy = params => {
  let newParams = Array.isArray(params) ? [] : {};
  if (typeof params != 'object') {
    newParams = params;
    return newParams;
  }
  if (params instanceof Array) {
    // debugger;
    for (let i = 0; i < params.length; i++) {
      if (typeof params[i] == 'object') {
        newParams[i] = recursionCopy(params[i]);
      } else {
        newParams[i] = params[i];
      }
    }
  } else {
    for (let key in params) {
      if (Reflect.has(params, key)) {
        if (typeof params[key] == 'object') {
          newParams[key] = recursionCopy(params[key]);
        } else {
          newParams[key] = params[key];
        }
      }
    }
  }
  return newParams;
};
const deepByIdSearchName = (list, id, key) => {
  if (list.length) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === id) {
        return list[i][key];
      }
      if (list[i].children && list[i].children) {
        let next = deepByIdSearchName(list[i].children, id, key);
        if (next) {
          return next;
        }
      }
    }
  }
  return;
};

// 数组自定义变量去重
const deWidthFn = (data, name, value) => {
  if (value) {
    let newData = [];
    let map = new Map();
    for (const item of data) {
      if (item[name] === value) {
        map.set(item[name], item);
      } else {
        newData.push(item);
      }
    }
    newData.push(...map.values());
    return newData;
  } else {
    let map = new Map();
    for (const item of data) {
      if (!map.has(item[name])) {
        map.set(item[name], item);
      }
    }
    return [...map.values()];
  }
};
export { COLUMNS, DATA_SCOPE_RULES, DATA_AUTHORITY_TYPE, REPLACE_DEPARTMENT_FIELDS, AUTHORITY_TAGTYPE, mergeCells, recursionCopy, deepByIdSearchName, deWidthFn };